import React from "react";
import axios from "axios";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CallIcon from "@material-ui/icons/Call";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";

import Constants from "./../../../Utils/Constants";
import LoadingProgress from "./../../../Common/LoadingProgress";
import { getToken, getHeaders } from "./../../../Utils/Common";
import store from "./../../../Common//storage";
import Header from "./../../../assets/components/header";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import Pagination from '@material-ui/lab/Pagination';
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { useClipboard } from "use-clipboard-copy";
import toastMaker from "./../../../Common/toastmaker.js";
import jsPDF from 'jspdf';


import "./../../../index.css";


const StyledTableCell = withStyles((theme) => ({
  body: {
    fontSize: 16,
    fontWeight: 600,
    padding: 15,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(251, 220, 119, 0.28)",
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "100%",
  },
});

ChartJS.register(ArcElement, Tooltip, Legend);

export default function FullScreenDialog(props) {
  const classes = useStyles();
  const [campaignData, setCampaignData] = React.useState();
  const [serverData, setServerData] = React.useState();
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const [open, setOpen] = React.useState(0);
  const [dialogTitle, setDialogTitle] = React.useState('');
  const [dialogData, setDialogData] = React.useState('');
  const [linkClickCount, setLinkClickCount] = React.useState(0);
  const [usClickCount, setUsClickCount] = React.useState(0);

  let id = window.location.pathname.split('/').pop()

  const handleChange = (event, value) => {
    setPage(value);
  };

  React.useEffect(() => {
    axios.get(Constants.getApiPathWithConfigId(Constants.campaignhistoryApiPath) + `/${id}`, getHeaders())
                      .then(response => {
                        setCampaignData(response.data.data)
                      }).catch(error => console.error(error))
  }, []);

  React.useEffect(() => {
    refreshData();
  }, [page]);

  const refreshData = () => {
    axios.get(Constants.getApiPathWithConfigId(Constants.campaignsmslogsApiPath) + `/${id}?per_page=10&page=${page}&order_by=id&order=desc`, getHeaders())
                      .then(response => {
                        setPageCount(response.data.meta.last_page)
                        setServerData(response.data.data)
                        var lcd  = response.data.data.map(d => d.link_click_data)
                        var lcc  = 0
                        var uscd = response.data.data.map(d => d.unsub_link_click_data)
                        var uscc = 0
                        lcd.map(l => l == null ? 0 : JSON.parse(l).length).map(l => lcc = lcc + l)
                        uscd.map(l => l == null ? 0 : JSON.parse(l).length).map(l => uscc = uscc + l)
                        uscd.map(l => l == null ? 0 : JSON.parse(l).length).map(l => uscd = uscc + l)
                        setLinkClickCount(lcc)
                        setUsClickCount(uscc)
                        
                      }).catch(error => console.error(error))
  };

  const data = {
    labels: ["DELIVERED", "UNDELIVERABLE"],
    datasets: [
      {
        label: "Delivery Report",
        data: [campaignData?.sp_number_of_contacts - campaignData?.failed_count, campaignData?.failed_count],
        backgroundColor: [
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 99, 132, 0.6)",
          // "rgba(255, 206, 86, 0.6)",
          // "rgba(75, 192, 192, 0.6)",
          // "rgba(153, 102, 255, 0.6)",
        ],
        borderColor: [
          "rgba(54, 162, 235, 1)",
          "rgba(255, 99, 132, 1)",
          // "rgba(255, 206, 86, 1)",
          // "rgba(75, 192, 192, 1)",
          // "rgba(153, 102, 255, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  const getSms = r => {
    let g = JSON.parse(r.personalization_tags)
    let m = r.sms
    for(let p in g) {
      m = m.replace(p, g[p])
    }
    return m
  }

  const close = () => {
    setDialogTitle('')
    setDialogData('')
    setOpen(0)
  }

  const clipboard = useClipboard({
    onSuccess() {
      toastMaker.makeToast(
        `Great! Report summary has been copied successfully.`,        
        {
          variant: "success",
        }
      );
      
    },
    onError() {
      toastMaker.makeToast("'Failed to copy report!'", {
        variant: "error",
      });
    },
  });

  const manageDownload = type => {
    switch(type) {
      case('pdf'):
        downloadpdf()
        break;
      case('excel'):
        downloadexcel()
        break;
      default:
        alert('Unknown entity');
    }
  }

  const downloadpdf = async () => {
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.text("Campaign Report", 105, 10, { align: "center" });
    doc.setFontSize(8);

    let y = 20;
    const lines = [
      `Campaign: ${campaignData?.name}`,
      `Sender ID: ${campaignData?.sender_id}`,
      `Date: ${new Date(campaignData?.created_at).toLocaleString()}`,
      `List: ${campaignData?.list_ac_names}`,
      `Segment: ${campaignData?.segment_ac_names}`,
      `Total: ${campaignData?.sp_number_of_contacts || 0}`,
      `Delivered: ${campaignData?.sp_number_of_contacts - campaignData?.failed_count}`,
      `Undeliverable: ${campaignData?.failed_count}`,
      `Percentage: ${
        (
          ((campaignData?.sp_number_of_contacts - campaignData?.failed_count) /
            (campaignData?.sp_number_of_contacts || 1)) *
          100
        ).toFixed(2)
      }%`,
      `Link Clicks: ${linkClickCount}`,
      `Unsubscribe Clicks: ${usClickCount}`,
    ];

    lines.forEach((line) => {
      doc.text(line, 15, y);
      y += 6;
    });

    const delivered = campaignData?.sp_number_of_contacts - campaignData?.failed_count;
    const undeliverable = campaignData?.failed_count;

    // Create hidden canvas for chart
    const canvas = document.createElement("canvas");
    canvas.width = 200;
    canvas.height = 200;
    document.body.appendChild(canvas);

    const ctx = canvas.getContext("2d");

    new ChartJS(ctx, {
        type: "pie",
        data: {
          labels: ["Delivered", "Undeliverable"],
          datasets: [
            {
              data: [delivered, undeliverable],
              backgroundColor: ["#ADD8E6", "#FFB6C1"], // light blue / light pink
              borderColor: "#ffffff",
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                color: "#000000",
                font: {
                  size: 24, // 🔹 larger, readable font
                  family: "Arial",
                  weight: "bold",
                },
                boxWidth: 26, // slightly larger color boxes
                padding: 10,
              },
            },
            tooltip: {
              bodyFont: { size: 20 },
              titleFont: { size: 22, weight: "bold" },
            },
          },
        },
      });

    // Wait for chart to render
    await new Promise((resolve) => setTimeout(resolve, 800));

    // Convert chart to image
    const chartImg = canvas.toDataURL("image/png");

    // Add to PDF
    doc.addImage(chartImg, "PNG", 60, y + 5, 80, 80);

    // Clean up DOM
    canvas.remove();

    doc.save("campaign-report.pdf");


  }

  const downloadexcel = () => {
    alert('Downloading Exel')
  }

  const types = ['SMS', 'MMS'];

  const statuses = [
  /* 0 =>  */ 'In Progress',                // Created and ready for configuration                | Step 1 | User 
  /* 1 =>  */ 'Completed',                  // Executed AKA Archived                              | Step 7 | System
  /* 2 =>  */ 'Completed',                // Configured and pending execution                     | Step 4 | System
  /* 3 =>  */ 'Completed',                // Execution in progress                                | Step 6 | System
  /* 4 =>  */ 'Completed',                  // Error occured while execution                      | Step 7 | System
  /* 5 =>  */ 'In Progress',                // Partially completed and stopped by user (Pause)    | Step 8 | System
  /* 6 =>  */ 'In Progress',                  // Configured and waiting for execution time        | Step 2 | User
  /* 7 =>  */ 'In Progress',                // Fetching contacts from AC                          | Step 3 | System
  /* 8 =>  */ 'In Progress',                // Pushing contacts to SP                             | Step 5 | System
  /* 9 =>  */ 'Cancelled',                  // Cancelled or deleted campaign                      | Step 9 | User
  /* 10 => */ 'In Progress',
  /* 11 => */ 'Scheduled',
  /* 12 => */ 'Waiting for credits'
]
 
  if (!serverData) {
    return <LoadingProgress />;
  }

  return (
    <>
    <div className="panal-viewport"> 
      <Header name={"Campaign Report"} />
    </div>
    <div className="row mb-2 ml-2">
      <div className="col-4 p-2">
        {campaignData?.name}
      </div>
      <div className="col-8">
        {/* <p
        className="c-button c-button--secondary text-uppercase w-20 pull-right text-light m-1"
                    onClick={() => manageDownload('excel')}
                    >
                      Download Excel
                    </p> */}
        <p
        className="c-button c-button--secondary text-uppercase w-20 pull-right text-light m-1"
                    onClick={() => manageDownload('pdf')}
                    >
                      Download PDF
                    </p>
    <p
        className="c-button c-button--secondary text-uppercase w-20 pull-right text-light m-1"
                    onClick={() => {
                      if (clipboard.isSupported()) {
                        let report = `
Sender Id: ${campaignData?.sender_id}
Date: ${new Date(campaignData?.created_at).toLocaleString()}
List: ${campaignData?.list_ac_names}
Segment: ${campaignData?.segment_ac_names}
Total: ${campaignData?.sp_number_of_contacts || 0}
Delivered: ${campaignData?.sp_number_of_contacts - campaignData?.failed_count}
Undeliverable: ${campaignData?.failed_count}
Percentage: ${
            (((campaignData?.sp_number_of_contacts - campaignData?.failed_count) / (campaignData?.sp_number_of_contacts * 1)) * 100).toFixed(2) == 'NaN' ?
            0 :
            (((campaignData?.sp_number_of_contacts - campaignData?.failed_count) / (campaignData?.sp_number_of_contacts * 1)) * 100).toFixed(2)
          }%
Link Click: ${linkClickCount}
Unsubscribe Click: ${usClickCount}
`;
                        clipboard.copy(report);
                      } else {
                        toastMaker.makeToast(
                          "Copy to clipboard not supported by browser.",
                          {
                            variant: "error",
                          }
                        );
                      }
                    }}
                  >
                    Copy Report
                  </p>
     <p
        className="c-button c-button--secondary text-uppercase w-20 pull-right text-light m-1"
        onClick={() => {
          Constants.navigate(Constants.campaignhistory)
        }}
      >Back</p>
      </div>
    </div>
    

    <TableContainer component={Paper} className="pb-2" style={{marginTop: '-40px'}}>
            <Table className={classes.table} aria-label="customized table">
              <TableBody>
                <TableRow>

                  <StyledTableCell className="table-hd">
                  {/* <div className="speech-bubble">{campaignData?.name}</div> */}
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                  
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                      
                  </StyledTableCell>
                  
                  {/* <StyledTableCell className="table-hd"> */}
                     
                  {/* </StyledTableCell> */}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div className="d-flex flex-row">
        <Paper className={` p-2 `} style={{width: '30%'}}>
          <div className="d-flex">
            {/* <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Name: {campaignData?.name}</p> */}
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Sender Id: {campaignData?.sender_id}</p>
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Date: {new Date(campaignData?.created_at).toLocaleString('en-GB', {
                                                                                                            day: 'numeric',
                                                                                                            month: 'numeric',
                                                                                                            year: 'numeric',
                                                                                                            hour: 'numeric',
                                                                                                            minute: '2-digit',
                                                                                                            hour12: true
                                                                                                          })}</p>
          </div>
          <div className="d-flex">
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>List: {campaignData?.list_ac_names}</p>
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Segment: {campaignData?.segment_ac_names}</p>
          </div>
          <div className="d-flex">
            {/* <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Name: {campaignData?.name}</p> */}
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Type: {campaignData?.type}</p>
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Status: {statuses[campaignData?.status]}</p>
          </div>
          <div className="d-flex">
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Total: {campaignData?.sp_number_of_contacts || 0}</p>
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Delivered: {campaignData?.sp_number_of_contacts - campaignData?.failed_count}</p>
          </div>
          <div className="d-flex">
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Undeliverable: {campaignData?.failed_count}</p>
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Percentage: {
              (((campaignData?.sp_number_of_contacts - campaignData?.failed_count) / (campaignData?.sp_number_of_contacts * 1)) * 100).toFixed(2) == 'NaN' ?
              0 :
              (((campaignData?.sp_number_of_contacts - campaignData?.failed_count) / (campaignData?.sp_number_of_contacts * 1)) * 100).toFixed(2)
            }%</p>
          </div>
          <div className="d-flex">
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Link Click: {linkClickCount}</p>
            <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Unsubscribe Click: {usClickCount} </p>
          </div>
          <div style={{width: '75%', margin: '30px auto'}}>
            <Pie data={data} options={options} />
          </div>
      </Paper>
      <Paper className={` pb-2 flex-grow-1`}>
        {(statuses[campaignData?.status] == "Completed") ? <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow id="table-head_rw">
                  <StyledTableCell className="table-hd">
                    Sent Message
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                    Sender ID
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                    Contact
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                    Status
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                    Link Clicks
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {serverData?.length > 0 ? serverData?.map(r => <TableRow key={r.id}>
                    <StyledTableCell className="">
                      <div className="speech-bubble" style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px'}}>
                        {
                          r.type == 'mms' && <>
                            <p>{r.subject}</p>
                            <img src={r.file} width={200} />
                          </>
                        }
                        <p>{getSms(r)}</p>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className="">
                      <div className="speech-bubble" style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px'}}>
                        <span>{campaignData?.sender_id}</span>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className="">
                      <div className="speech-bubble" style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px'}}>
                        <span>{r.phone_number}</span>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className="">
                      <div className={r.status == 2 ? 'text-red' : 'text-green'} style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px'}}>
                        <span>{r.status == 2 ? 'UNDELIVERABLE' : 'DELIVERED'}</span>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell >
                      <div className="speech-bubble" style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', textAlign: 'center'}}>
                        <a href="#" className="text-success" onClick={() => {
                          setDialogTitle('Link Clicks')
                          setDialogData(r?.link_click_data)
                          setOpen(1)
                        }} 
                        title="Link clicks"
                        >{
                          JSON.parse(r?.link_click_data)?.length || 0
                        }</a> | <a href="#" className="text-danger" onClick={() => {
                          setDialogTitle('Unsubscribe Clicks')
                          setDialogData(r?.unsub_link_click_data)
                          setOpen(1)
                        }}
                        title="Unsubscribe link clicks"
                        >{
                          JSON.parse(r?.unsub_link_click_data)?.length || 0
                          }
                        </a> 
                      </div>
                    </StyledTableCell>
                  </TableRow>
                ) : <TableRow>
                    <StyledTableCell className="">
                      <div className="speech-bubble" style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px'}}>
                        <span>No data found.</span>
                      </div>
                    </StyledTableCell>
                  </TableRow>
                }
              </TableBody>
            </Table>
          </TableContainer> : <span>Please wait for the campaign to complete.</span>
          }
          {pageCount > 0 && <div className={`${classes.root} mt-3 mb-3 d-flex justify-content-end`}>
                    <Pagination 
                      count={pageCount} 
                      page={page} 
                      onChange={handleChange} 
                      variant="outlined" 
                      shape="rounded"
                      />
                  </div>}
                  
        </Paper>
        <Dialog
          onClose={close}
          aria-labelledby="simple-dialog-title"
          open={open}
        >
          <DialogTitle id="simple-dialog-title">
            {dialogTitle}
          </DialogTitle>
          <DialogContent>
            <div className="form-groups">
              {
                dialogData ? <>
                  <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">
                      <TableHead>
                        <TableRow id="table-head_rw">
                          <StyledTableCell className="table-hd">
                            Link
                          </StyledTableCell>
                          <StyledTableCell className="table-hd">
                            Date
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dialogData && JSON.parse(dialogData)?.map((r, i) => <TableRow key={i}>
                            <StyledTableCell className="">
                              <div className="speech-bubble" style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px'}}>
                                <span>
                                  <a href={r?.eventDetails?.link} target="_blank" title={r?.eventDetails?.link}>
                                    {r?.eventDetails?.link.substr(0, 40)}...
                                  </a>
                                </span>
                              </div>
                            </StyledTableCell>
                            <StyledTableCell className="">
                              <div className="speech-bubble" style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px'}}>
                                <span>{new Date((r?.timestamp * 1000)).toLocaleDateString()}</span>
                              </div>
                            </StyledTableCell>
                          </TableRow>
                        ) 
                        }
                      </TableBody>
                    </Table>
                  </TableContainer> 
                </> : <span>No data found.</span>
              }
            </div>
          </DialogContent>
          <DialogActions style={{ padding: "8px 24px 24px" }}>
            <span
              className="c-button text-uppercase"
              style={{ marginRight: "10px" }}
              onClick={close}
            >
              Close
            </span>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
